import FluxReduceStore from "flux/lib/FluxReduceStore";
import fluxRuntime from "../../apps/data/fluxRuntime";
import { AllPayloads } from "../../apps/data/payloads";
import BasicRecord from "./BasicRecord";

const reduxReducers: BasicRecord<unknown> = { };

function convertStoreToReducer<State>(store: FluxReduceStore<State, AllPayloads>) {
    if (!store || !store.getState || !store.reduce) {
        return;
    }

    const reducerBoundThis = store;

    return function reducer(state = store.getState(), action: AllPayloads) {
        return store.reduce.call(reducerBoundThis, state, action);
    };
}

// Converts given flux stores into redux reducers
function convertFluxStoresToReduxReducers() {
    Object.values(fluxRuntime.stores)
        .forEach(storeToBeConverted => {
            const reducer = convertStoreToReducer(storeToBeConverted);

            if (reducer) {
                const storeName = fluxRuntime.storeNames[storeToBeConverted.getDispatchToken()];

                reduxReducers[storeName] = reducer;
            }
        });

    return reduxReducers;
}

export default convertFluxStoresToReduxReducers;
